import { render } from "./bukuProfil.vue?vue&type=template&id=4451c2f9"
import script from "./bukuProfil.vue?vue&type=script&lang=js"
export * from "./bukuProfil.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__